import Vue from 'vue'
import Component from 'vue-class-component'
import RemoveButton from '../buttons/RemoveButton.vue'
import convoStore from '../../store/convo/convo-store'
import { IStatement } from '../../model/statement'

@Component({
  name: 'statementRemove',
  props: ['statement'],
  components: { 'remove-button' : RemoveButton },
})
export default class StatementRemove extends Vue {

  protected removeFormStatement(statement: IStatement): void {
    convoStore.dispatchRemoveFormStatement(this.$props['statement'])
  }

}
